import React from 'react';
import { HelpCircle } from 'react-feather';
import { useLocation } from 'react-use';
import styles from './Help.module.scss';

const Help = () => {
    const location = useLocation();

    if (location.pathname !== '/') return null;

    return (
        <a className={styles.launcher} href="https://www.boomreader.co.uk/help" target="_blank" rel="noopener noreferrer">
            <HelpCircle size={14.4} aria-hidden="true" />
            <span>Help</span>
        </a>
    );
};

export default Help;
